import classNames from "classnames";
import React from "react";

type Props = {
  label?: string;
  value: boolean;
  onChange: (value: boolean) => void;
  description?: string;
  descriptionPosition?: "left" | "right";
  size?: "md" | "sm";
};

const sizeClasses = {
  md: {
    track: "h-[26px] w-12 rounded-2xl p-0.5",
    thumb: "h-[22px] w-[22px]",
    thumbActive: "translate-x-[22px]",
    text: "text-sm",
  },
  sm: {
    track: "h-[18px] w-[34px] rounded-2xl p-[2px]",
    thumb: "h-[14px] w-[14px]",
    thumbActive: "translate-x-[16px]",
    text: "text-xs",
  },
};

export const Swiper: React.FC<Props> = ({
  label,
  value,
  onChange,
  description,
  descriptionPosition = "left",
  size = "md",
}) => {
  const currentSize = sizeClasses[size];

  return (
    <div className={"flex flex-col gap-3"}>
      {label && (
        <div
          className={classNames(
            "font-medium text-[#3F5266]",
            currentSize.text,
          )}>
          {label}
        </div>
      )}

      <div className={"flex items-center gap-2.5"}>
        {description && descriptionPosition === "left" && (
          <div
            className={classNames(
              "font-medium text-[#1D2C3B]",
              currentSize.text,
            )}>
            {description}
          </div>
        )}

        <div
          onClick={() => onChange(!value)}
          className={classNames(
            "relative cursor-pointer transition-colors duration-300",
            currentSize.track,
            value ? "bg-[#6938EF]" : "bg-[#A1AFC0]",
          )}>
          <div
            className={classNames(
              "absolute rounded-full bg-white transition-transform duration-300",
              currentSize.thumb,
              value ? currentSize.thumbActive : "translate-x-0",
            )}
          />
        </div>

        {description && descriptionPosition === "right" && (
          <div
            className={classNames(
              "font-medium text-[#1D2C3B]",
              currentSize.text,
            )}>
            {description}
          </div>
        )}
      </div>
    </div>
  );
};
